import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React, {useEffect, useState} from 'react';
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import {useDispatch, useSelector} from "react-redux";
import {getServiceRequest, updateServiceRequest} from "../../../../api/serviceRequest/ServiceRequestService";
import {resetContents, setCode, setHandlers, setSequencingCodeName} from "../../../../redux/slice/contentSlice";
import {apiLoading, skeleton} from "../../../../redux/slice/apiSlice";
import {SLARadioAttributes} from "../../../../constant/RadioGroupAttributes";
import ServiceRequestExamine from "./ServiceRequestExamine";
import {TaskManager} from "../../../maintenance/shared/TaskManager";
import ServiceRequestFeedback from "./ServiceRequestFeedback";
import SimmsInput from "../../../../components/input/SimmsInput";
import {inputOnChange, inputOnKeyDown} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";

const ServiceRequestInfo = ({id}) => {
    const [serviceRequest, setServiceRequest] = useState({});

    const selectedUsers = useSelector(state => state.content.selectedUsers);
    const sequencingCodeName = useSelector(state => state.content.sequencingCodeName);
    const refreshContent = useSelector(state => state.status.refreshContent);
    const progressStatusValue = useSelector(state => state.content.progressStatusValue);
    const contentApproval = useSelector(state => state.content.contentApproval);

    const dispatch = useDispatch();

    const canEditRequest = (contentApproval) => {
        if (!contentApproval?.contentApprovalGroups?.length) {
            return false;
        }

        const actualApprovalGroups = contentApproval.contentApprovalGroups
            .filter(group => group.approvalType !== "HAS_NO_APPROVERS");

        const sortedActualGroups = actualApprovalGroups
            .sort((a, b) => a.orders - b.orders);

        return sortedActualGroups[0].approvalType === "PENDING";
    };

    useEffect(() => {
        if (!id) return;
        setServiceRequest({});
        handleCallServiceRequest();
        dispatch(skeleton(false));
        dispatch(resetContents());
        return () => dispatch(resetContents());
    }, [id, refreshContent]);

    const handleCallServiceRequest = async () => {
        dispatch(apiLoading(true));
        const response = await getServiceRequest({id, progressStatus: ContentStatus.APPROVE.statusValue});
        if (response && response.status === 200) {
            dispatch(apiLoading(false));
            const data = response.data;
            setServiceRequest({...data});
            dispatch(setHandlers([...data.handlers]));
            const codes = response.data.serviceCodes;
            if (codes && codes.length > 0) {
                const codeNames = codes.map(code => code.name).join(" > ");
                const code = codes.pop();
                dispatch(setSequencingCodeName(codeNames));
                dispatch(setCode({...code}));
            }
        }
    }

    const editable = progressStatusValue.statusNumericValue === 30
        && canEditRequest(contentApproval)
        && serviceRequest.serviceApplyId === null;
    const requestInfoPanel = (
        <>
            <DetailPanel title={"기본정보"}>
                <DetailKvTable>
                    <tbody>
                    {editable ? (
                        <tr>
                            <Th_title title={"요청제목"} colspan={3} className="fieldset-td" auth>
                                <SimmsInput onChange={(v)=>inputOnChange(setServiceRequest,"title", v, true)}
                                            update onKeyDown={(v, e)=>inputOnKeyDown(setServiceRequest, updateServiceRequest, serviceRequest.id, "title", v, e, true)}
                                            data={serviceRequest.title} />
                            </Th_title>
                        </tr>
                    ) : (
                        <tr>
                            <Th_title title={"요청제목"} className="fieldset-td" colspan={3}>
                                <ReadOnlyInputBasic value={serviceRequest.title} />
                            </Th_title>
                        </tr>
                    )}

                    {editable ? (
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"요청내용"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setServiceRequest,"description", v, false)}
                                               update onKeyDown={(v, e)=>inputOnKeyDown(setServiceRequest, updateServiceRequest, serviceRequest.id, "description", v, e, false)}
                                               style={{minHeight:'80px'}}
                                               data={serviceRequest.description} />
                            </Th_title>
                        </tr>
                    ) : (
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"요청내용"} className="fieldset-td" colspan={3}>
                                <div className={`align-text-div`}>{serviceRequest.description}</div>
                            </Th_title>
                        </tr>
                    )}

                    <tr>
                        <Th_title title={"등록일자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"createdAt"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.createdAt}
                            />
                        </Th_title>
                        <Th_title title={"수정일자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"updatedAt"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.updatedAt}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"createdBy"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.createdBy?.name}
                            />
                        </Th_title>
                        <Th_title title={"수정자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"updatedBy"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.updatedBy?.name}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"applier"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.applier?.name}
                            />
                        </Th_title>
                        <Th_title title={"접수자"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"requester"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.requester?.name}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청마감일"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"requestCloseDate"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.requestCloseDate}
                            />
                        </Th_title>
                        <Th_title title={"일련번호"} className="fieldset-td" colspan={1}>
                            <ReadOnlyInputBasic
                                target={"contentSerial"}
                                data={{data: serviceRequest, setData: setServiceRequest}}
                                value={serviceRequest.serialNumber}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청코드"} className="fieldset-td" colspan={3}>
                            <span>{sequencingCodeName}</span>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"SLA 사용여부"} className="fieldset-td" colspan={3}>
                            {SLARadioAttributes.map((item) =>
                                String(serviceRequest.sla) === item.value &&
                                <React.Fragment key={item.value}>{item.text}</React.Fragment>
                            )}
                        </Th_title>
                    </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    );

    const workflowPanels = (
        <>
            {/*변경된 요청마감일이 있거나 반려되었으면 */}
            {(serviceRequest.adjustedRequestCloseDate || progressStatusValue.rejected === ContentStatus.REJECT.statusValue) && (
                <DetailPanel title={"검토관리"}>
                    <DetailKvTable>
                        <tbody>
                        {/*요청마감일이 변경된경우*/}
                        {serviceRequest.adjustedRequestCloseDate && (
                            <tr>
                                <Th_title title={"조정정보"} className="fieldset-td" colspan={3}>
                                    <div className={`px-[12px] py-2`}>{`요청 마감 조정일 : ${serviceRequest.adjustedRequestCloseDate}`}</div>
                                    <div className={"mt-2 align-text-div"}>{serviceRequest.adjustDescription}</div>
                                </Th_title>
                            </tr>
                        )}
                        {/*반려된 경우*/}
                        {progressStatusValue.rejected === ContentStatus.REJECT.statusValue && (
                            <tr>
                                <Th_title title={"반려정보"} className="fieldset-td" colspan={3}>
                                    <div>{`반려자 : ${progressStatusValue.rejectUser.department ? `[${progressStatusValue.rejectUser.department.name}]` : ''} ${progressStatusValue.rejectUser.name}`}</div>
                                    <div className={"mt-2"}>{progressStatusValue.description}</div>
                                </Th_title>
                            </tr>
                        )}
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            )}
            <ServiceRequestFeedback
                serviceRequest={serviceRequest}
                initialData={{
                    id: serviceRequest.id,
                    feedbackUserId: serviceRequest.feedbackUserId,
                    feedbackRating: serviceRequest.feedbackRating,
                    feedbackDescription: serviceRequest.feedbackDescription,
                    feedbackDate: serviceRequest.feedbackDate,
                }}
            />
            <TaskManager
                data={serviceRequest}
                contentCategory={ContentCategory.SERVICE_REQUEST}
                statusRows={(
                    <>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"처리담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue
                                    items={serviceRequest.handlers ?? []}
                                    listType={KV_LIST_TYPES.user}
                                />
                            </Th_title>
                        </tr>
                    </>
                )}
            />
            <ServiceRequestExamine serviceRequest={serviceRequest}/>

        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent
                auth
                contentId={serviceRequest.id}
                contentCategory={ContentCategory.SERVICE_REQUEST}
            />
            {serviceRequest.serviceApplyId && (
                <DetailFilePanel
                    title="서비스신청 파일"
                    isEditing={false}
                    tableInfo={{
                        tableName: ContentCategory.SERVICE_APPLY,
                        joinKey: serviceRequest.serviceApplyId,
                    }}
                />
            )}
            <DetailFilePanel
                title="첨부"
                isEditing={false}
                tableInfo={{
                    tableName: ContentCategory.SERVICE_REQUEST,
                    joinKey: serviceRequest.id,
                }}
            />
        </>
    );

    return (
        <>
            {Object.keys(serviceRequest).length > 0 && (
                <ContentDetailInfoShell
                    title={serviceRequest.title || "접수 상세"}
                    meta={sequencingCodeName || serviceRequest.serialNumber}
                    contentId={id}
                    contentCategory={ContentCategory.SERVICE_REQUEST}
                    scrollMode="columns"
                    listUrl="/serviceRequest/serviceRequest"
                    rollup={{cancel: {url: "/serviceRequest/serviceRequest"}, data: serviceRequest}}
                >
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={workflowPanels}
                        aside={asidePanel}
                    />
                </ContentDetailInfoShell>
            )}
        </>
    );
};

export default ServiceRequestInfo;
